module.exports = __webpack_public_path__ + "static/media/snakke_lavt.1ff273fd.m4a";